import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { TopBarComponent } from './top-bar/top-bar.component';
import { AuthHeaderComponent } from "./auth-header/auth-header.component";
import { AppRoutingModule } from "@src/app/app-routing.module";
import { AdminPanelComponent } from './admin-panel/admin-panel.component'; 
import { NgxUiLoaderModule } from 'ngx-ui-loader';



@NgModule({
  declarations: [NavBarComponent, TopBarComponent, AdminPanelComponent],
  imports: [
    CommonModule,
    AuthHeaderComponent,
    AppRoutingModule,
    NgxUiLoaderModule
  ],
  exports: [NavBarComponent, TopBarComponent]
})
export class LayoutModule { }
